<template>
    <div class="main">
        <!-- Top container-->
        <div class="top-container">
            <!--Left column-->
            <div class="column left-column">
                <div class="title">Welcome to MyStekz</div>
                <div>The Intelligent Automation development platform.</div>
                <div>Better software made easy.</div>
                <br />
                <div class="buttons">
                    <router-link to="/signup" class="signup">
                        <Button
                            label="Create an account"
                            raised
                            class="signup-button"
                        />
                    </router-link>
                    <p>
                        Already have an account?
                        <router-link to="/login" class="login">
                            Sign in.
                        </router-link>
                    </p>
                </div>
            </div>

            <!--Right column-->
            <div class="column right-column">
                <img
                    class="header-graphic"
                    src="https://stekz.com/wp-content/uploads/2023/01/mystekz.png"
                />
            </div>
        </div>

        <!-- Bottom container-->
        <div class="bottom-container">
            <div class="subtitle">
                Used to build rock solid SAAS platforms for industry leaders
            </div>
            <div>
                STX Group, Perium, Urban Woods, Grassland, TVM, TakeAware,
                Absolute Motors, Urban, GP Products, Wovar, NOM, Van Vuuren,
                Yarinde, NoMilk2Day,...and many more!
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useAuthenticationManager } from "@/stores/authentication-store";

// Has the side-effect of redirecting you to the correct page when logged
// in.
useAuthenticationManager();
</script>

<style scoped>
.main {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    color: white;
    background-color: var(--stekz-primary-color);
    padding: 30px;
}

.top-container {
    /* Distribute child elements horizontally. */
    display: flex;
    flex-direction: row;
}
.column {
    /* Equal width for columns */
    flex: 1;
}
.column-right {
    display: flex;
    flex-direction: column;
    /* Center horizontally */
    justify-content: center;
    /* Center vertically */
    align-items: center;
}
.title {
    font-size: 50px;
    padding-bottom: 30px;
}

.subtitle {
    font-size: 30px;
    padding-bottom: 30px;
}

.header-graphic {
    /* Ensure image fits within the column */
    max-width: 100%;
    /* Maintain aspect ratio */
    height: auto;
}

.buttons {
    display: flex;
    flex-direction: column;
    /* gap: 1rem; */
    margin-top: 20px;
    justify-content: start;
}

.login-button,
.signup-button {
    background-color: var(--stekz-dev-color);
    color: var(--stekz-white);
}

.bottom-container {
    padding-top: 100px;
}
</style>
